import React, { FC, ReactNode } from 'react';
import { Footer } from './components/Footer';
import { Header, HeaderProps } from './components/Header';
import { Content, Main, PageLayout, TopNavigation } from '@atlaskit/page-layout';
import { LanguageBar } from './components/LanguageBar';
import NotificationFlagGroup from './components/notifications/NotificationFlagGroup';
import { Box, xcss } from '@atlaskit/primitives';

const layoutContentStyles = xcss({
  width: '100%',
  minHeight: 'calc(100vh - var(--topNavigationHeight, 56px))',
  display: 'grid',
  gridTemplateRows: '1fr auto',
  gridTemplateColumns: '100%',
});

const mainStyles = xcss({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  margin: '0 auto',
  maxWidth: '1200px',
  padding: 'space.200',
  paddingTop: 'space.400',
});

interface OwnProps extends HeaderProps {
  children?: ReactNode;
}

const LayoutWrapper: FC<OwnProps> = ({ headerContent, children }) => (
  <>
    <LanguageBar />
    <NotificationFlagGroup />
    <PageLayout>
      <TopNavigation testId='top-navigation'>
        <Header headerContent={headerContent} />
      </TopNavigation>
      <Content testId='content'>
        <Box xcss={layoutContentStyles}>
          <Main testId='main'>
            <Box xcss={mainStyles}>{children}</Box>
          </Main>
          <Footer />
        </Box>
      </Content>
    </PageLayout>
  </>
);

export default LayoutWrapper;
